import {tva} from "@gluestack-ui/nativewind-utils/tva";
import {Box} from "@hosttools/frontend";
import type React from "react";
import {forwardRef, memo} from "react";

interface Props {
    fluid?: boolean;
    fitHeight?: boolean;
    className?: string;
    children: React.ReactNode;
}

const style = tva({
    base: "w-full min-h-[auto] md:px-7",
    variants: {
        fitHeight: {
            true: "flex-1 overflow-y-auto"
        },
        fluid: {
            false: "max-w-[1440px] mx-auto w-full"
        }
    }
});

const ContentWrapper = (
    {children, fluid = false, fitHeight = false, className}: Props,
    ref: React.ForwardedRef<HTMLDivElement>
) => {
    return (
        <Box
            ref={ref}
            // `react-select` needs to be visible in case of tight view
            // overflowY={fitHeight ? "auto" : "visible"}
            // overflowY="auto"
            // `auto` breaks `flex: 1` so that it can scroll nicely on mobile
            // minHeight={["auto", 0]}
            className={style({fitHeight, fluid, className})}
            testID="box-content-wrapper"
        >
            {children}
        </Box>
    );
};

ContentWrapper.displayName = "ContentWrapper";

const FowardRefComponent = forwardRef<HTMLDivElement, Props>(ContentWrapper);

FowardRefComponent.displayName = `forwardedRef(${ContentWrapper.displayName})`;

export default memo(FowardRefComponent);
